import m from 'mithril'

import { removeParam } from 'core/helpers/url-helpers'

class Transition {
  constructor(vnode) {
    this.transitionComplete = this._transitionComplete.bind(this, vnode)
  }

  oninit() {
    let state = this
  }

  oncreate() {
    let state = this

    setTimeout(state.transitionComplete, 5000)
  }

  onbeforeremove(vnode) {
    vnode.dom.classList.add('is-exiting')
    return new Promise(resolve => {
      vnode.dom.addEventListener('animationend', resolve)
    })
  }

  _transitionComplete(vnode) {
    removeParam('transition')
  }

  view(vnode) {
    let state = this
    return (
      <div className="transition">
        <h3>We're transitioning to the next pano</h3>
        <p>{vnode.attrs.transition.text}</p>
      </div>
    )
  }
}

export default Transition
